import { IconPlus, IconX } from "@hawkins/assets";
import * as Accordion from "@radix-ui/react-accordion";
import cx from "classnames";
import { FragmentOf } from "gql.tada";
import { RichEntryFragment } from "@queries/fragments/RichEntryFragment";
import { RichText } from "@components/shared/core/RichText";

interface FaqItemProps {
  id: number | string;
  title: string;
  description?: FragmentOf<typeof RichEntryFragment> | null;
  className?: string;
}

export const FaqItem = ({
  id,
  title,
  description,
  className = "",
}: FaqItemProps) => {
  return (
    <Accordion.Item
      value={`item-${id}`}
      className={cx(
        "w-full mt-4",
        "rounded-2xl overflow-hidden",
        "backdrop-blur-[25px]",
        "group/item",
        "cursor-pointer",
        "data-[state=closed]:text-brand-cream data-[state=closed]:bg-brand-cream/[0.08] hover:data-[state=closed]:bg-brand-cream/[0.12]",
        "data-[state=open]:bg-brand-cream data-[state=open]:text-brand-black",
        "transition-all",
        className
      )}
    >
      <Accordion.Header className="w-full">
        <Accordion.Trigger
          className={cx(
            "flex justify-between items-center w-full",
            "px-4 py-6 dsk:px-9 dsk:py-[38px]",
            "text-left",
            "group/trigger",
            "cursor-pointer"
          )}
        >
          <span className="text-body-large dsk:text-body-regular pr-4">
            {title}
          </span>
          <div className="relative flex-shrink-0 flex items-center justify-center w-6 h-6">
            <IconPlus
              size="small"
              className={cx(
                "absolute w-6 h-6",
                "transition-[transform,opacity]",
                "group-data-[state=open]/trigger:opacity-0",
                "group-data-[state=open]/trigger:rotate-45"
              )}
            />
            <IconX
              size="small"
              className={cx(
                "absolute w-6 h-6",
                "transition-[transform,opacity]",
                "group-data-[state=closed]/trigger:opacity-0",
                "group-data-[state=closed]/trigger:-rotate-45"
              )}
            />
          </div>
        </Accordion.Trigger>
      </Accordion.Header>
      <Accordion.Content
        className={cx(
          "group",
          "data-[state=closed]:animate-accordionUp",
          "data-[state=open]:animate-accordionDown",
          "overflow-hidden"
        )}
      >
        <div
          className="px-4 py-6 dsk:px-9 dsk:pb-9 text-body-regular font-normal [&_*]:text-brand-black"
          style={{
            transformOrigin: "top",
          }}
        >
          <RichText content={description} />
        </div>
      </Accordion.Content>
    </Accordion.Item>
  );
};
